import React from 'react'

type ProgressItem = {
  label: string
  percent: number
}

type BadgeAwarenessCardProps = {
  iconSlug?: string
  title: string
  subtext?: string
  progress: ProgressItem[]
  width?: number | string
  height?: number | string
  className?: string
}

const BadgeAwarenessCard: React.FC<BadgeAwarenessCardProps> = ({
  iconSlug,
  title,
  subtext,
  progress,
  width,
  height,
  className = '',
}) => (
  <div
    className={`rounded-md p-6 flex items-start ${className}`}
    style={{
      width,
      height,
      gap: 20,
      border: '1px solid #E8E8E8',
    }}
  >
    {iconSlug && (
      <img
        src={`/assets/svg/badge-${iconSlug}.svg`}
        alt={title}
        className="object-contain"
        style={{ width: 104, height: 122 }}
      />
    )}
    <div className="flex flex-col gap-4 flex-1">
      <div className="text-left flex flex-col gap-1">
        <p className="font-sans text-base font-semibold leading-4 tracking-normal text-brand">
          {title}
        </p>
        {subtext && (
          <p className="font-sans text-xs font-normal leading-4 tracking-normal text-[#303030]">
            {subtext}
          </p>
        )}
      </div>
      {progress.map((p, i) => (
        <BadgeProgressRow key={i} label={p.label} percent={p.percent} />
      ))}
    </div>
  </div>
)

const BadgeProgressRow: React.FC<ProgressItem> = ({ label, percent }) => (
  <div className="flex flex-col gap-1">
    <div className="flex items-center justify-between">
      <span className="font-sans text-xs font-semibold leading-4 tracking-normal text-gray-medium">
        {label}
      </span>
      <span className="font-sans text-xs font-semibold leading-4 tracking-normal text-center text-gray-medium">
        {percent.toFixed(2)}%
      </span>
    </div>
    <div
      className="h-2 bg-[#E8E8E8] overflow-hidden"
      style={{ borderRadius: 999 }}
    >
      <div
        className="h-full"
        style={{
          width: `${Math.min(100, Math.max(0, percent))}%`,
          background: '#5EA3E0',
          borderRadius: 999,
        }}
      />
    </div>
  </div>
)

export default BadgeAwarenessCard
